document.querySelectorAll( '.b-dropdown' ).forEach( ( block ) => {

	const dropdowns = block.querySelectorAll( '.b-dropdown__item' );

	dropdowns.forEach( ( dropdown ) => {

		const trigger = dropdown.querySelector( '.b-dropdown__item-button' );
		const content = dropdown.querySelector( '.b-dropdown__item-wrapper' );

		content.style.maxHeight = content.style.maxHeight ? null : `${content.scrollHeight}px`;

		trigger.addEventListener( 'click', () => {

			content.style.maxHeight = content.style.maxHeight ? null : `${content.scrollHeight}px`;
			dropdown.classList.toggle( 'close' );

		} );

	} );

	/**
	 * Debounce
	 *
	 * @param {function} callback
	 * @param {integer} delay
	 * @return {(function(...[*]): void)|*}
	 */
	const debounce = ( callback, delay ) => {

		let timeout;
		return function executedFunction( ...args ) {

			/** */
			const later = () => {

				clearTimeout( timeout );
				callback( ...args );

			};
			clearTimeout( timeout );
			timeout = setTimeout( later, delay );

		};

	}
	/**
	 * Recalculate heights of open accordion items on window resize
	 */
	const recalculateOpenAccordions = () => {

		block.querySelectorAll( '.b-dropdown__item:not(.close)' ).forEach( ( accordion ) => {

			const content = accordion.querySelector( '.b-dropdown__item-wrapper' );
			const newHeight = content.scrollHeight;
			content.style.maxHeight = `${newHeight}px`;

		} );

	};
	const debounceRecalculateAccordion = debounce( recalculateOpenAccordions, 50 );
	window.addEventListener( 'resize', debounceRecalculateAccordion );

} );
